import { DefaultGrid } from "../../../../components/grids/default/defaultGrid"
import { v4 as uuidv4 } from 'uuid';
import useGridFilter from "../../../../system/hooks/useGridFilter";
import { GosContractItemsPluginSettings } from "../pluginSettings/gosContractItemsPluginSettings";
import { useCallback, useEffect, useReducer, useState } from "react";
import { useAppContext } from "../../../../system/providers/appContextProvider";
import { usePluginContext } from "../../../../system/providers/plugin";
import { initialState, reducer } from "../state/GosContractItems/reducer";
import { GosContractDataProvider } from "../../../../Services/DataProviders/GosContractDataProvider";

export const GosContractItemsPluginView = () => {
    const appCtx = useAppContext();
    const pluginCtx = usePluginContext();
    const gosContractDP = new GosContractDataProvider(appCtx.coreApiService);
    const [gridFilter, dispatchGridFilter] = useGridFilter();

    const [state, dispatch] = useReducer(reducer, initialState)

    const loadItems = useCallback((gridFilter: any, callback?: (entities: any[]) => void) => {
        if (!pluginCtx.masterGrid.selectedItem?.idGlobal) {
            dispatch({ type: 'setItems', payload: { items: [], totalCount: 0 } });
            return;
        }

        gosContractDP.getItemsView(
            pluginCtx.masterGrid.selectedItem.idGlobal,
            gridFilter,
            (entities, totalCount) => {
                dispatch({ type: 'setItems', payload: { items: entities, totalCount } });
                callback?.(entities);
            }
        );
    }, [pluginCtx.masterGrid.selectedItem?.idGlobal]);

    useEffect(() => {
        loadItems(gridFilter);
    }, [pluginCtx.masterGrid.selectedItem?.idGlobal, gridFilter, loadItems]);

    return <DefaultGrid
        gridId={uuidv4()}
        data={state.items}
        totalCount={state.totalCount}
        filter={gridFilter}
        dataProvider={gosContractDP}
        plugin={GosContractItemsPluginSettings}
        selectedItem={undefined}
        getView={(gridFilter, callback) => loadItems(gridFilter, callback)}
        onSelect={() => {}}
        onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
        onFilterDelete={(i) => dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName })}
        onPageNumberChange={(n) => dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
        onNumberPerPageChange={(n) => dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
    />
}